export default __webpack_public_path__ + "static/media/maksim.2e3ec0bb.jpg";